import { Modal } from "@mui/material";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Close, ZoomIn, ZoomOut } from "@mui/icons-material";
import classes from "@styles/post/postImages.module.css";
import Image from "next/image";
export default function FullScreenViewImage({
  openModal,
  closeModal,
  imageSrc,
  height,
  width,
  smallScreen
}) {
  return <Modal open={openModal} data-sentry-element="Modal" data-sentry-component="FullScreenViewImage" data-sentry-source-file="FullScreenImageView.jsx">
      <div className={classes.fullViewContainer}>
        <Close fontSize="large" className={classes.closeFullView} onClick={closeModal} data-sentry-element="Close" data-sentry-source-file="FullScreenImageView.jsx" />

        <TransformWrapper defaultScale={1} defaultPositionX={1} defaultPositionY={1} data-sentry-element="TransformWrapper" data-sentry-source-file="FullScreenImageView.jsx">
          {({
          zoomIn,
          zoomOut,
          ...rest
        }) => <>
              <TransformComponent>
                {smallScreen ? <Image src={imageSrc} className={classes.fullViewImg} alt="Full Screen Image View" width={width} height={height}
            //layout="fill"
            //objectFit="cover"
            /> : <Image src={imageSrc} className={classes.fullViewImg} alt="Full Screen Image View" width={width} height={height} layout="responsive" objectFit="cover" />}
              </TransformComponent>

              <div className={classes.fullViewButtons}>
                <span onClick={() => zoomIn()} className={classes.zoomInStyles}>
                  <ZoomIn fontSize="large" />
                  <small>ZoomIn</small>
                </span>
                <span onClick={() => zoomOut()} className={classes.zoomOutStyles}>
                  <ZoomOut fontSize="large" /> <small>ZoomOut</small>
                </span>
              </div>
            </>}
        </TransformWrapper>
      </div>
    </Modal>;
}